export default __webpack_public_path__ + "locales/de/DowngradePlanDialog.json?hash=dbc2b9fd1a03785a9be1447cb671a481";